import { OtherComponent } from './uploads/other/other.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CallbackComponent } from './callback/callback.component';
import { DocumentsComponent } from './documents/documents.component';
import { EmployerDocumentHistoryComponent } from './documents/employer-document-history/employer-document-history.component';
import { HelpComponent } from './help/help.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { NewsDetailsComponent } from './news/news-details/news-details.component';
import { PayScheduleComponent } from './pay-schedule/pay-schedule.component';
import { PayrollComponent } from './payroll/payroll.component';
import { ManageBankingInfoComponent } from './profiles/manage-banking-info/manage-banking-info.component';
import { ManageUsersComponent } from './profiles/manage-users/manage-users.component';
import { ProfilesComponent } from './profiles/profiles.component';
import { ViewOrgInfoComponent } from './profiles/view-org-info/view-org-info.component';
import { UploadsComponent } from './uploads/uploads.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { MemberDocUploadComponent } from './documents/member-doc-upload/member-doc-upload.component';
import { ContactInfoComponent } from './account/contact-info/contact-info.component';
import { AuthGuard } from './shared/services/auth/auth-guard.service';
import { InvoiceComponent } from './invoice/invoice.component';
import { PayrollReportsComponent } from './payroll/payroll-reports/payroll-reports.component';
import { AdjustmentReportsComponent } from './payroll/adjustment-reports/adjustment-reports.component';
import { ForbiddenComponent } from './forbidden/forbidden.component';
import { ServiceErrorComponent } from './shared/service-error/service-error.component';
import { MemberDocumentHistoryComponent } from './documents/member-document-history/member-document-history.component';
import { EmployeesComponent } from './employees/employees.component';
import { TerminateComponent } from './employees/terminate/terminate.component';
import { EarningsLimitationComponent } from './uploads/earnings-limitation/earnings-limitation.component';
import { MemberDocumentsComponent } from './uploads/member-documents/member-documents.component';
import { SlRecertificationComponent } from './uploads/sl-recertification/sl-recertification.component';
import { RetireeDeductionsComponent } from './uploads/retiree-deductions/retiree-deductions.component';
import { AdjustmentReportsV2Component } from './payroll/adjustment-reports-v2/adjustment-reports-v2.component';
import { CutoffNoticesComponent } from './employees/cutoff-notices/cutoff-notices.component';
import { EnrollmentsComponent } from './employees/enrollments/enrollments.component';

const routes: Routes = [
  { path: 'landing-page', component: LandingPageComponent },
  { path: 'home', component: HomeComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'news-details/:id', component: NewsDetailsComponent },
  {
    path: 'payroll', component: PayrollComponent, canActivate: [AuthGuard],
    children: [
      { path: 'payroll-reports', component: PayrollReportsComponent },
      { path: 'adjustment-reports', component: AdjustmentReportsComponent },
      { path: 'adjustment-reports-v2', component: AdjustmentReportsV2Component }
    ]
  },
  { path: 'invoice', component: InvoiceComponent, canActivate: [AuthGuard] },
  { path: 'pay-schedule', component: PayScheduleComponent, canActivate: [AuthGuard] },
  {
    path: 'profiles', component: ProfilesComponent, canActivate: [AuthGuard],
    children: [
      { path: 'manage-users', component: ManageUsersComponent },
      { path: 'view-organization-information', component: ViewOrgInfoComponent },
      { path: 'banking-information', component: ManageBankingInfoComponent },
    ]
  },
  {
    path: 'employees', component: EmployeesComponent, canActivate: [AuthGuard],
    children: [
      { path: 'enrollments', component: EnrollmentsComponent },
      { path: 'terminate', component: TerminateComponent },
      { path: 'cutoff-notices', component: CutoffNoticesComponent },
    ]
  },
  {
    path: 'uploads', component: UploadsComponent, canActivate: [AuthGuard], data: { title: 'Uploads' },
    children: [
      { path: 'member-document', component: MemberDocumentsComponent },
      { path: 'sick-leave-recertification', component: SlRecertificationComponent },
      { path: 'earnings-limitation', component: EarningsLimitationComponent },
      { path: 'retiree-deductions', component: RetireeDeductionsComponent },
      { path: 'other', component: OtherComponent }
    ]
  },
  { path: 'employer-documents', component: EmployerDocumentHistoryComponent, canActivate: [AuthGuard] },
  {
    path: 'documents', component: DocumentsComponent, canActivate: [AuthGuard],
    children: [
      { path: 'view-employer-documents', component: EmployerDocumentHistoryComponent },
      { path: 'member-document-history', component: MemberDocumentHistoryComponent },
      { path: 'member-document-upload', component: MemberDocUploadComponent }
    ]
  },
  { path: 'help', component: HelpComponent },
  {
    path: 'account', component: ContactInfoComponent, canActivate: [AuthGuard], data: { title: 'Account' },
    children: [
      { path: '', redirectTo: 'contact-information', pathMatch: 'full' },
      { path: 'contact-information', component: ContactInfoComponent }]
  },
  { path: 'forbidden', component: ForbiddenComponent },
  { path: 'serviceerror', component: ServiceErrorComponent, canActivate: [AuthGuard] },
  { path: '', component: LoginComponent, data: { title: 'Login' } },
  { path: 'login', component: LoginComponent, data: { title: 'Login' } },
  { path: '**', redirectTo: '/login', pathMatch: 'full' }];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
